import { createAction, props } from '@ngrx/store';
import { WaiverData } from 'src/app/core/models/itinerary.model';

export const RouteTabTo = createAction(
  '[Search-Result/ Tab]  Route Tab to ',
  props<{ activeTab: string }>()
);

export const ChangeExceptionMode  = createAction(
  '[Search-Result]  Change Exception Mode ',
  props<{ exceptionMode: boolean }>()
);

export const HideOrShowExceptionSwitch  = createAction(
  '[Search-Result]  Hide Or Show Exception Switch ',
  props<{ show: boolean }>()
);

export const SaveWaiverData  = createAction(
  '[Search-Result]  Save waiver data',
  props<{ waiverData: WaiverData }>()
);

